import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  GetLeadAssignmentFormSourceGQL,
  GetLeadAssigmentByIdGQL,
  NewLeadAssignmentGQL,
  EditLeadAssignmentGQL,
  GetLeadAssignmentSalesStaffGQL
} from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";
import {
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";
import { GraphQLError } from "graphql";
import 'rxjs/add/operator/debounceTime';
import { FormValidators } from "../../form-validators/form-validators";

export interface DialogData {
  projectId: string,
  //**isNewForm true if add record else edit record.. */
  isNewForm: string,
  leadAssignmentId?: string,
}

@Component({
  selector: "lead-automation-dialog",
  templateUrl: "lead-automation-dialog.html",
})
export class LeadAutomationDialog {
  formControls;
  formSource: any[] = [];
  dialogBoxTitle: string;
  //#region Balance Weight Variables
  balanceWeight: number = 0;
  insertedWeight: number = 0;
  totalBalanceWeight: number = 0;
  //#endregion
  staffName: any[] = [];
  staffFilterList: any[] = [];
  //#region  SeqNo global variables */
  seqNoList: Number[] = [];
  previousSeqNo: number = 0;
  isSeqNoNew: boolean = false;
  //#endregion
  roundRobinAssignmentForm: FormGroup;

  displayStaffName(obj?: any): string | undefined {

    return obj ? obj.userName || obj.staffName : undefined;
  }


  constructor(
    public dialogRef: MatDialogRef<LeadAutomationDialog>,
    private getLeadAssignmentFormSourceGQL: GetLeadAssignmentFormSourceGQL,
    private snackbarSvc: SnackBarService,
    private getLeadAssigmentByIdGQL: GetLeadAssigmentByIdGQL,
    private newLeadAssignmentGQL: NewLeadAssignmentGQL,
    private editLeadAssignmentGQL: EditLeadAssignmentGQL,
    private getLeadAssignmentSalesStaffGQL: GetLeadAssignmentSalesStaffGQL,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    data?.isNewForm ? this.dialogBoxTitle = "New" : this.dialogBoxTitle = "Edit"
    this.InitFormControl();
    this.getFormSource();
  }


  InitFormControl() {
    this.roundRobinAssignmentForm = new FormGroup({
      salesStaff: new FormControl("", [Validators.required, FormValidators.forbiddenObjectValidator]),
      weight: new FormControl("", [Validators.required, Validators.min(1)])
    })

    this.formControls = this.roundRobinAssignmentForm.controls;

    this.formControls.salesStaff.valueChanges.subscribe((x) => {
      if (typeof x !== "object") {
        let staff = this.staffName;
        if (x) {
          staff = this.staffName.filter((y) =>
            y.userName.toUpperCase().includes(x.toUpperCase())
          );
        }
        this.staffFilterList = Object.assign([], staff);
      }
    });

  }

  private getFormSource() {
    this.getLeadAssignmentFormSourceGQL.fetch().subscribe((result) => {
      if (result.errors) {
        this.snackbarSvc.showQueryError(result.errors);
        this.dialogRef.close();
      }
      this.formSource = result.data.getLeadAssignmentFormSource;
      if (this.formSource) {
        this.balanceWeight = this.calculateBalanceWeight(result.data.getLeadAssignmentFormSource.map(x => x.weight));
        this.totalBalanceWeight = this.balanceWeight * 100;
        this.getSalesStaff();
      }
      if (!this.data.isNewForm) {
        this.setFormValue();
      }
    })

  }
  /**
   * Get list of sales staff.
   */
  private getSalesStaff() {
    let filteredStaff: boolean = false;
    this.data.isNewForm ? filteredStaff = true : filteredStaff = false
    this.getLeadAssignmentSalesStaffGQL.fetch().subscribe((result) => {
      if (result.errors) {
        this.snackbarSvc.showQueryError(result.errors);
        this.dialogRef.close();
      }
      this.staffName = result.data.getLeadAssignmentSalesStaff;

      this.staffFilterList = Object.assign([], this.staffName);
    })
  }

  /**
   * if isNewForm false proceed to patch record by lead assignment Id.
  */
  private setFormValue() {
    if (!this.data.leadAssignmentId) {
      this.snackbarSvc.show("Lead Assigment Id Is Required.")
      this.dialogRef.close();
    }

    this.getLeadAssigmentByIdGQL.fetch({
      leadAssigmentId: this.data.leadAssignmentId,
    }).subscribe((result) => {
      if (result.errors) {
        this.snackbarSvc.showQueryError(result.errors);
      }
      const weight = result.data.getLeadAssigmentById.weightage * 100;
      this.insertedWeight = weight;
      this.roundRobinAssignmentForm.setValue({
        salesStaff: { staffId: result.data.getLeadAssigmentById.staffId, userName: result.data.getLeadAssigmentById.staffName },
        weight: weight
      })
    })
  }

  /**
   * Calculate remning balance weight fetched from database.
   * @param weight 
   */
  private calculateBalanceWeight(weight: number[]) {
    let totalWeight = weight.reduce((a, b) => a + b, 0);
    let balanceWeight = (100 - (totalWeight * 100));
    //**Set max validator based on balanceWeight */
    if (this.data.isNewForm) {
      this.setWeightControlMaxValidator(balanceWeight);
    }
    return balanceWeight / 100;
  }

  private setWeightControlMaxValidator(balanceWeight: number) {
    this.roundRobinAssignmentForm.controls.weight.clearValidators();
    this.roundRobinAssignmentForm.controls.weight.setValidators(
      [Validators.max(balanceWeight), Validators.required, Validators.min(1)]
    )
  }

  public onWeightChange(weight) {
    if (this.data.isNewForm) return;
    weight = weight ? weight : 0;
    let changedWeight = parseInt(weight) / 100;
    let totalBalanceWeight = this.balanceWeight * 100 + this.insertedWeight;
    if (changedWeight > totalBalanceWeight / 100) {
      this.setWeightControlMaxValidator(totalBalanceWeight);
    } else {
      this.roundRobinAssignmentForm.controls.weight.clearValidators();
      this.roundRobinAssignmentForm.controls.weight.setValidators(
        [Validators.required, Validators.min(1)]
      )
    }
  }


  /**
   * Submit form based on submission type either add or edit.
   * @param value 
   */
  submitAssignment(value) {
    this.roundRobinAssignmentForm.markAllAsTouched();
    const formValue = value.controls;
    if (this.roundRobinAssignmentForm.valid) {

      //**If isNewForm true will proceed to create new record. */
      if (this.data.isNewForm) {
        this.newLeadAssignmentGQL.mutate({
          input: {
            userId: formValue.salesStaff.value.ID || formValue.salesStaff.value.staffId,
            weight: Number(formValue.weight.value / 100)
          }
        }).subscribe((result) => {
          if (result.data.newLeadAssignment) {
            this.snackbarSvc.show("New Round Robin Assigned.")
            this.dialogRef.close(true);
          }
        },
          (err: GraphQLError) => {
            this.snackbarSvc.showMutationError(err);
          })

        //**If isNewForm false will proceed to update existing record. */
      } else {
        this.editLeadAssignmentGQL.mutate({
          input: {
            leadAssignmentId: this.data.leadAssignmentId,
            userId: formValue.salesStaff.value.ID || formValue.salesStaff.value.staffId,
            weight: Number(formValue.weight.value / 100),
          }
        }).subscribe((result) => {
          if (result.data.editLeadAssignment) {
            this.snackbarSvc.show("Editted Successfully.")
            this.dialogRef.close(true);
          }
        },
          (err: GraphQLError) => {
            this.snackbarSvc.showMutationError(err);
          })
      }
    } else if (!this.roundRobinAssignmentForm.valid) {
      this.snackbarSvc.show(
        "Please complete or correct the required field(s)."
      );
    }

  }
}
